import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as BackArrow } from
  '../../../assets/chevron-outline.svg';

import { CERTIFICATE_LINKING_STEPS } from '../petDemographics.constants';

import styles from './BaseLayout.module.css';

const BackButton = ({
  currentStep = CERTIFICATE_LINKING_STEPS.LANDING,
  handleGoBack = () => { },
}) => {
  const { t } = useTranslation('petDemos');

  if (currentStep === CERTIFICATE_LINKING_STEPS.LANDING) {
    return null;
  }

  return (
    <button
      className={styles.goBackButton}
      onClick={handleGoBack}
      type="button"
    >
      <BackArrow className={styles.backArrow} />

      <span>{t('certificateLinking.common.goBack')}</span>
    </button>
  );
};

export { BackButton };
